import { render, staticRenderFns } from "./ObiNotFound.vue?vue&type=template&id=5beebac6&scoped=true&"
import script from "./ObiNotFound.vue?vue&type=script&lang=js&"
export * from "./ObiNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ObiNotFound.vue?vue&type=style&index=0&id=5beebac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beebac6",
  null
  
)

export default component.exports